/**
 * DetailContent section.
 */
import Animator from '@components/elements/animator/animator';
import Event from '@components/sections/detail/ui/detailEvent';
import Metadata from '@components/sections/detail/ui/detailMetadata';
import Related from '@components/elements/detail/detailRelated';
import VerticalAnimation from '@components/atoms/container/verticalAnimationContainer';
import useDetailContent from '@components/sections/detail/lib/useDetailContent';
import { TRANSITION } from '@shared/types/constants/animations';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Renders the detail content section. Includes the event information, metadata, and related content.
 */
export default function DetailContent() {
  const { props } = useDetailContent();
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  return (
    <Animator
      {...props.container}
      type={Animator.Type.DETAIL}
      collapse={{ horizontal: menuExpanded }}
    >
      <VerticalAnimation
        transition={TRANSITION.DETAIL_SCROLL}
        {...props.animation}
      >
        <Event />
        <Metadata />
        <Related />
      </VerticalAnimation>
    </Animator>
  );
}
